import React, { Component } from 'react';
import cx from 'classnames';
import Text from '../../Text/Text';
import Icon from '../../Icon';














export default class FiltersGroupContainer extends Component


{
  constructor(props) {
    super(props);

    this.state = {
      opened: !!props.openedByDefault
    };
  }

  toggleOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState(({ opened }) => ({ opened: !opened }));
  };

  render() {
    const {
      isCollapsible,
      label,
      children,
      className = '',
      minWidth
    } = this.props;
    const { opened } = this.state;

    const width = minWidth ? `${minWidth}px` : 'auto';

    return (
      <div
        className={cx('advanced-filters__group__container', className, {
          'advanced-filters__group__container--opened': isCollapsible && opened,
          'advanced-filters__group__container--closed': isCollapsible && !opened
        })}
        style={{ minWidth: width }}>

        <div
          className={cx('advanced-filters__group__header', {
            'advanced-filters__group__header--empty': !label
          })}>

          {label && <Text heading3>{label}</Text>}
          {isCollapsible &&
          <div className="advanced-filters__toggle-button">
              <Icon
              name={opened ? 'chevronup' : 'chevrondown'}
              size={16}
              onClick={this.toggleOpen}
              color="black" />

            </div>}

        </div>
        <div
          className={cx('advanced-filters__group__wrapper', {
            'advanced-filters__group__wrapper--opened': isCollapsible && opened,
            'advanced-filters__group__wrapper--closed': isCollapsible && !opened
          })}>

          {children}
        </div>
      </div>);

  }
}